import React from 'react';
import Icon from '@amzn/awsui-components-core/icon';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
import { StudioReportDetails, type StudioStartingPointProps } from 'src/components/star-grid/components/StudioReportDetails';
import styles from 'src/components/star-grid/components/styles/StudioHeader.module.scss';
interface Props extends StudioStartingPointProps {
  readonly state: ReportStudioState;
  readonly chooser?: React.ReactNode;
}
const StudioDeckContext: React.FC<{ readonly state: ReportStudioState }> = ({ state }) => (
  <div className={styles.deckContext}>
    {state.draft.definition.active_deck && (
      <p className={styles.contextHelp}>
        <Icon name="status-info" size="small" />
        <span>
          {state.text('studioEditingDeckHelp')} <strong>{state.draft.definition.active_deck}</strong>.
        </span>
      </p>
    )}
  </div>
);
export const StudioHeader: React.FC<Props> = ({ state, ...details }) => (
  <section className={styles.card} aria-label={state.text('createReportDetails')} data-testid="studio-report-header">
    <StudioReportDetails state={state} {...details} />
    <StudioDeckContext state={state} />
  </section>
);
